import Navbar from './ui/Navbar';
import AppDrawer from './ui/AppDrawer';
import { useScreenResolution } from '../utils/utils';
import Typography from '@mui/material/Typography';
import { useContext, useState } from 'react';
import CartContext from '../contexts/CartContext';
import CartModal from './CartModal';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const cartStyles = {
  color: 'text.primary',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    textDecoration: 'underline',
    textDecorationThickness: '4px',
    textUnderlineOffset: '2px',
  },
};

const NavMenu = () => {
  const isDesktop = useScreenResolution();

  // cart
  const [openCartModal, setOpen] = useState(false);
  const handleOpenCart = () => setOpen(true);
  const handleCloseCart = () => setOpen(false);
  const { cartTotalItems } = useContext(CartContext);
  const renderShoppingCartLink = (isIcon = false) => (
    <Typography
      sx={{
        ...cartStyles,
        justifyContent: isIcon ? 'flex-end' : '',
        marginRight: isIcon ? '10px' : 0,
      }}
      onClick={handleOpenCart}
    >
      {!isIcon && `Shopping Cart (${cartTotalItems})`}
      {isIcon && <ShoppingCartOutlinedIcon />}
    </Typography>
  );

  return (
    <>
      <CartModal open={openCartModal} handleClose={handleCloseCart} />
      {isDesktop ? (
        <Navbar>{renderShoppingCartLink()}</Navbar>
      ) : (
        <AppDrawer rightLinkSlot={renderShoppingCartLink(true)}>
          {renderShoppingCartLink()}
        </AppDrawer>
      )}
    </>
  );
};

export default NavMenu;
